import type { ReactNode } from 'react'
import { Layout } from './components/Layout'
import { ArticlePage } from './pages/ArticlePage'
import { ContactPage } from './pages/ContactPage'
import { HomePage } from './pages/HomePage'
import { InsightsPage } from './pages/InsightsPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { ServicesPage } from './pages/ServicesPage'
import { resolveRoute } from './lib/routes'

interface AppProps {
  pathname: string
}

export function App({ pathname }: AppProps) {
  const route = resolveRoute(pathname)

  let page: ReactNode
  if (route.name === 'home') page = <HomePage />
  else if (route.name === 'services') page = <ServicesPage />
  else if (route.name === 'contact') page = <ContactPage />
  else if (route.name === 'insights') page = <InsightsPage />
  else if (route.name === 'article' && route.article) page = <ArticlePage article={route.article} />
  else page = <NotFoundPage />

  return <Layout>{page}</Layout>
}
